export var APP_EVENTS;
(function (APP_EVENTS) {
    APP_EVENTS[APP_EVENTS["RELOAD_PAGE"] = 0] = "RELOAD_PAGE";
    APP_EVENTS[APP_EVENTS["MAP_ZOOM_IN"] = 1] = "MAP_ZOOM_IN";
    APP_EVENTS[APP_EVENTS["MAP_ZOOM_OUT"] = 2] = "MAP_ZOOM_OUT";
    APP_EVENTS[APP_EVENTS["SCROLL_TO"] = 3] = "SCROLL_TO";
    APP_EVENTS[APP_EVENTS["BACK_EVENT"] = 4] = "BACK_EVENT";
    APP_EVENTS[APP_EVENTS["SHOW_INFORMATION"] = 5] = "SHOW_INFORMATION";
    APP_EVENTS[APP_EVENTS["START"] = 6] = "START";
    APP_EVENTS[APP_EVENTS["SAVE"] = 7] = "SAVE";
    APP_EVENTS[APP_EVENTS["CREATE"] = 8] = "CREATE";
    APP_EVENTS[APP_EVENTS["DELETE"] = 9] = "DELETE";
    APP_EVENTS[APP_EVENTS["EDIT"] = 10] = "EDIT";
    APP_EVENTS[APP_EVENTS["SHARE"] = 11] = "SHARE";
    APP_EVENTS[APP_EVENTS["POSITION"] = 12] = "POSITION";
    APP_EVENTS[APP_EVENTS["CUSTOM"] = 13] = "CUSTOM";
})(APP_EVENTS || (APP_EVENTS = {}));
/**
 * represents the mode used in the app
 */
export var ACCESSIBILITY_MODE;
(function (ACCESSIBILITY_MODE) {
    ACCESSIBILITY_MODE[ACCESSIBILITY_MODE["ACCESSIBLE"] = 0] = "ACCESSIBLE";
    ACCESSIBILITY_MODE[ACCESSIBILITY_MODE["NOTACCESSIBLE"] = 1] = "NOTACCESSIBLE";
})(ACCESSIBILITY_MODE || (ACCESSIBILITY_MODE = {}));
//# sourceMappingURL=app.enums.js.map